<template>
  <div class="menu-item py-5">
    <a v-if="isLink" class="menu-title" :href="menu.link">{{ menu.title }}</a>
    <span v-else class="menu-title">{{ menu.title }} </span>
    <ul class="submenu-list">
      <li
        v-for="(submenu, index) in menu.submenus"
        :key="index"
        class="submenu-item"
      >
        <a :href="submenu.link" class="submenu-link">
            <img :src="iconSrc" height="10px" alt="icono" class="arrow-icon">
          <span class="submenu-title">{{ submenu.title }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data(){
    return {
      iconSrc: 'https://assets-intranet-security.s3.us-east-2.amazonaws.com/shortcut-icon.svg',
    }
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isLink() {
      return this.menu.link && this.menu.link.trim() !== '';
    }
  }
};

</script>

<style scoped>
.menu-title {
  text-decoration: none;
  color: #232272;
  font-size: 1.5rem;
  list-style: none;
  margin-bottom: 10px;
  font-weight: 600;
}

.submenu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.submenu-item {
  margin: 5px 0;
}

.submenu-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  margin-bottom: .5rem
}

.arrow-icon {
  margin-right: 10px;
}

.submenu-title {
  font-size: 1.1rem;
}
</style>
